var exports = {
  "iU": "Message.module__message___OEtiVj",
  "Ph": "Message.module__messagePreviewSpacing___OEtiVj",
  "IL": "Message.module__messagePreview___OEtiVj",
  "Xo": "Message.module__messageHovered___OEtiVj",
  "uK": "Message.module__focusRingAnchor___OEtiVj",
  "J8": "Message.module__messageCompact___OEtiVj",
  "L8": "Message.module__messageMentioned___OEtiVj",
  "m6": "Message.module__messageReplying___OEtiVj",
  "O6": "Message.module__messageHighlight___OEtiVj",
  "lY": "Message.module__contextMenuActive___OEtiVj",
  "Bc": "Message.module__mobileLayout___OEtiVj",
  "p2": "Message.module__messageLongPress___OEtiVj",
  "Uw": "Message.module__messageGrouped___OEtiVj",
  "kT": "Message.module__messageEditing___OEtiVj",
  "E4": "Message.module__messageSent___OEtiVj",
  "mr": "Message.module__messageSending___OEtiVj",
  "b$": "Message.module__messageFailed___OEtiVj",
  "RZ": "Message.module__failedFooter___OEtiVj",
  "Iu": "Message.module__failedFooterMessage___OEtiVj",
  "bg": "Message.module__failedFooterLabel___OEtiVj",
  "OZ": "Message.module__failedFooterIcon___OEtiVj",
  "dv": "Message.module__failedRetryIcon___OEtiVj",
  "QW": "Message.module__failedRetryButton___OEtiVj",
  "q5": "Message.module__messageGutterLeft___OEtiVj",
  "ZN": "Message.module__messageGutterRight___OEtiVj",
  "$7": "Message.module__messageAvatar___OEtiVj",
  "CW": "Message.module__messageNoText___OEtiVj",
  "U7": "Message.module__messageContent___OEtiVj",
  "rO": "Message.module__messageAuthorInfo___OEtiVj",
  "xW": "Message.module__jumpHeading___OEtiVj",
  "RO": "Message.module__jumpHeadingButton___OEtiVj",
  "dw": "Message.module__messageAuthorRow___OEtiVj",
  "um": "Message.module__messageUsername___OEtiVj",
  "Lo": "Message.module__messageText___OEtiVj",
  "AY": "Message.module__messageAuthorPart___OEtiVj",
  "oL": "Message.module__messageTimestamp___OEtiVj",
  "L5": "Message.module__messageTimestampCompact___OEtiVj",
  "tQ": "Message.module__compactAuthorPrefix___OEtiVj",
  "U6": "Message.module__copyOnly___OEtiVj",
  "Mz": "Message.module__compactInlineContent___OEtiVj",
  "aM": "Message.module__systemMessageContent___OEtiVj",
  "vp": "Message.module__contextMenuUnderline___OEtiVj",
  "aE": "Message.module__messageTimeoutIndicator___OEtiVj",
  "t4": "Message.module__textSeparator___OEtiVj",
  "BK": "Message.module__authorDashSeparator___OEtiVj",
  "KL": "Message.module__messageTimestampHover___OEtiVj",
  "jh": "Message.module__messageTimestampCompactHover___OEtiVj",
  "iZ": "Message.module__messageAvatarCompact___OEtiVj",
  "kq": "Message.module__compactContentWrapper___OEtiVj",
  "xv": "Message.module__hoverAction___OEtiVj",
  "kL": "Message.module__container___OEtiVj",
  "tI": "Message.module__repliedMessage___OEtiVj",
  "_T": "Message.module__repliedMessageCompact___OEtiVj",
  "$y": "Message.module__repliedTextPreview___OEtiVj",
  "NL": "Message.module__repliedAvatar___OEtiVj",
  "a3": "Message.module__repliedIconContainer___OEtiVj",
  "Pq": "Message.module__repliedIcon___OEtiVj",
  "EK": "Message.module__repliedUsername___OEtiVj",
  "IQ": "Message.module__repliedItalic___OEtiVj",
  "Mx": "Message.module__unstyled___OEtiVj",
  "Io": "Message.module__repliedTextContent___OEtiVj",
  "c": "Message.module__systemMessageFollowsSystem___OEtiVj",
  "Hj": "Message.module__systemMessageIconWrapper___OEtiVj",
  "Po": "Message.module__systemMessageIconCompact___OEtiVj",
  "jJ": "Message.module__systemMessageTimestamp___OEtiVj",
  "rc": "Message.module__systemMessageContentWrapper___OEtiVj",
  "V_": "Message.module__systemMessageCompactContent___OEtiVj",
  "Gq": "Message.module__systemMessageIconSvg___OEtiVj",
  "hr": "Message.module__systemMessageLink___OEtiVj",
  "x": "Message.module__userTagOffset___OEtiVj",
  "ll": "Message.module__userTagCompact___OEtiVj",
  "O4": "Message.module__editedTimestamp___OEtiVj",
  "k8": "Message.module__editedLabel___OEtiVj",
  "zX": "Message.module__typingContainer___OEtiVj",
  "Y9": "Message.module__typingCluster___OEtiVj",
  "RL": "Message.module__typingIndicator___OEtiVj",
  "Kl": "Message.module__typingAvatarContainer___OEtiVj",
  "tY": "Message.module__typingText___OEtiVj",
  "AZ": "Message.module__typingClusterComposerStatus___OEtiVj",
  "am": "Message.module__compactContentNoPrefix___OEtiVj",
  "Ys": "Message.module__compactBody___OEtiVj",
  "Ac": "Message.module__unknownMessageCompactContent___OEtiVj",
  "qU": "Message.module__unknownMessageWarning___OEtiVj",
  "NG": "Message.module__keyboardFocused___OEtiVj",
  "an": "Message.module__messageClientSystem___OEtiVj",
  "og": "Message.module__systemMessageContainer___OEtiVj",
  "Is": "Message.module__systemMessageIcon___OEtiVj",
  "ry": "Message.module__mediaFocusRing___OEtiVj",
  "xS": "Message.module__systemMessageDismissButton___OEtiVj",
  "Eu": "Message.module__silentMessageIcon___OEtiVj",
};

module.exports = exports;
